<template>
  <div class="tarjeta">
    <div class="equipos">
      <span class="nombre-equipos">{{ partido.clubLocal }}</span>
      <v-img :src="partido.localLogo.logo" height="48px" width="48px" contain class="logo-club"></v-img>
      <span class="goles-equipos">
        {{ partido.localGoals }}
        <span v-if="partido.localPenaltyGoals" class="goles-penales">{{ `(${partido.localPenaltyGoals})` }}</span>
      </span>
      <span class="guion">-</span>
      <span class="goles-equipos">
        {{ partido.visitorGoals }}
        <span v-if="partido.visitorPenaltyGoals" class="goles-penales">{{ `(${partido.visitorPenaltyGoals})` }}</span>
      </span>
      <v-img :src="partido.visitorLogo.logo" height="48px" width="48px" contain class="logo-club"></v-img>
      <span class="nombre-equipos">{{ partido.clubVisitor }}</span>
    </div>
    <div class="informacion">
      <div>
        <v-icon class="icon" color="#676767">mdi-clock-outline</v-icon>
      <span class="fecha-partido">{{partido.dateRealization}}</span>
      </div>
      <div>
        <v-icon class="icon" color="#676767">mdi-soccer-field</v-icon>
      <span class="estadio-partido">{{partido.stadium}}</span>
      </div>
    </div>
    <div @click="goDetail" v-if="canGoToDetail()" class="tarjeta-selection">
        <v-icon color="black">mdi-chevron-right</v-icon>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    partido: null
  },
  methods: {
    goDetail () {
      this.$emit('goDetail', this.partido.id)
    },
    canGoToDetail () {
      if (this.$store.state.permissions.canViewFichaPartidoClub) {
        if (this.$store.getters.isSafRole) {
          return true
        }
        return this.$store.getters.club === this.partido.clubLocal || this.$store.getters.club === this.partido.clubVisitor
      }
    }
  },
  created () {
  }
}
</script>

<style scoped>
.tarjeta{
  background-color: #eeeeee;
  width: 90%;
  height: 60px;
  border-radius: 12px;
  margin-top: 15px;
  display: grid;
  grid-template-columns: 2fr 1.8fr 40px;
  overflow: hidden;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
}
.equipos{
  grid-column: 1/2;
  display: grid;
  align-items: center;
  grid-template-columns: 150px 60px 40px 30px 40px 60px 150px ;
  justify-self: start;
}
.informacion{
  grid-column: 2/2;
  display: flex;
  flex-direction: column;
  align-items: start;
  align-self: center;
  color: #293968;
  overflow: hidden;

}
.tarjeta-selection{
  grid-column: 3/3;
  align-self: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
}
.nombre-equipos{
  font-size: 16px;
  text-align: right;
  overflow-wrap: break-word;
  color: #293968;
}

.nombre-equipos:last-child{
  text-align: left;
  overflow-wrap: break-word;
}

.goles-equipos , .guion{
  font-size: 30px;
  text-align: center;
  color: #293968;
}

.goles-equipos{
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
}

.info-partido{
  font-size: 16px;
  color: #293968;
  padding-left: 5px;
}
.fecha-partido , .estadio-partido{
  font-size: 16px;
  color: #293968;
  padding-left: 5px;
}

.logo-club{
  justify-self: center;
}
.icon{
  vertical-align: top;
}
.goles-penales{
  font-size: 20px;
}

@media screen and (max-width: 1400px){
  .equipos{
    grid-template-columns: 140px 50px 50px 20px 50px 50px 140px ;
  }
}

@media screen and (max-width: 1280px){
  .icon{
    visibility: hidden;
  }
  .tarjeta{
    height: 80px;
  }
  .nombre-equipos{
    text-align: right;
    padding-left: 10px;
  }
  .nombre-equipos:last-child{
  padding-left: 10px;
  overflow-wrap: break-word;
}
  .goles-equipos , .guion{
  font-size: 20px;
  text-align: center;
  color: #293968;
}
}

@media screen and (max-width: 1190px){
  .equipos{
    grid-template-columns: 100px 50px 30px 20px 30px 50px 100px ;
  }
}

@media screen and (max-width: 1000px){
  .equipos{
    grid-template-columns: 100px 1px 20px 20px 20px 1px 100px ;
  }
  .logo-club{
    visibility: hidden;
  }
}

</style>
